function toValidDate(value: unknown): Date | null {
  if (value == null) return null;
  const d = value instanceof Date ? value : new Date(String(value));
  return Number.isNaN(d.getTime()) ? null : d;
}

export function canMarkInspectionAttendance(item: {
  listingInspection?: { inspectionStartTime?: unknown } | null;
  createdAt?: unknown;
}): boolean {
  const d =
    toValidDate(item.listingInspection?.inspectionStartTime) ??
    toValidDate(item.createdAt);
  if (!d) return false;
  const today = new Date();
  return (
    d.getFullYear() === today.getFullYear() &&
    d.getMonth() === today.getMonth() &&
    d.getDate() === today.getDate()
  );
}
